import { Link } from 'react-router-dom';

export type ViewKey = 'overview' | 'playbooks' | 'projects' | 'credits' | 'usage';

const NAV_ITEMS: { key: ViewKey; label: string; icon: string }[] = [
  { key: 'overview', label: 'Overview', icon: 'ri-layout-grid-line' },
  { key: 'playbooks', label: 'Playbooks', icon: 'ri-price-tag-3-line' },
  { key: 'projects', label: 'My Playbooks', icon: 'ri-folder-3-line' },
  { key: 'credits', label: 'Buy credits', icon: 'ri-flashlight-line' },
  { key: 'usage', label: 'Usage', icon: 'ri-bar-chart-2-line' },
];

export default function Sidebar({
  view,
  onChange,
  isAdmin,
}: {
  view: ViewKey;
  onChange: (v: ViewKey) => void;
  isAdmin?: boolean;
}) {
  return (
    <aside className="w-full lg:w-60 shrink-0 lg:h-[calc(100vh-64px)] lg:sticky lg:top-16 border-b lg:border-b-0 lg:border-r border-border bg-bg">
      <nav className="flex lg:flex-col gap-1 p-2 lg:p-3 overflow-x-auto lg:overflow-visible">
        {NAV_ITEMS.map((item) => {
          const active = view === item.key;
          return (
            <button
              key={item.key}
              onClick={() => onChange(item.key)}
              className={`whitespace-nowrap flex items-center gap-2.5 text-sm px-3 py-2 rounded-lg transition-colors ${
                active ? 'bg-surface text-textp' : 'text-texts hover:text-textp'
              }`}
            >
              <i className={`${item.icon} text-base ${active ? 'text-accent' : ''}`} />
              {item.label}
            </button>
          );
        })}
        {isAdmin && (
          <Link
            to="/admin"
            data-testid="superadmin-sidebar-link"
            className="whitespace-nowrap flex items-center gap-2.5 text-sm px-3 py-2 rounded-lg text-texts hover:text-textp transition-colors"
          >
            <i className="ri-shield-user-line text-base" />
            Superadmin
          </Link>
        )}
      </nav>

      <div className="hidden lg:block p-3 mt-auto">
        <div className="border-t border-border pt-4 px-1 space-y-2">
          <Link
            to="/studio"
            className="whitespace-nowrap flex items-center gap-2.5 text-sm text-texts hover:text-textp transition-colors"
          >
            <i className="ri-arrow-go-back-line text-base" />
            Back to Studio
          </Link>
          <Link
            to="/"
            className="whitespace-nowrap flex items-center gap-2.5 text-sm text-texts hover:text-textp transition-colors"
          >
            <i className="ri-home-line text-base" />
            Sourcetape site
          </Link>
        </div>
      </div>
    </aside>
  );
}
